module.exports = __webpack_public_path__ + "img/banner-edu.35c16d99.png";